import React, { useRef, useState } from 'react'
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, EffectFade, Swiper as SwiperType } from 'swiper'
// eslint-disable-next-line import/no-unresolved
import 'swiper/css'
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/effect-fade'
import loginHero from '../../assets/login-hero.png'
import slider1 from '../../assets/slider/slider-1.webp'
import slider2 from '../../assets/slider/slider-2.webp'
import slider3 from '../../assets/slider/slider-3.webp'
import slider4 from '../../assets/slider/slider-4.webp'
import slider5 from '../../assets/slider/slider-5.webp'
import slider6 from '../../assets/slider/slider-6.webp'
import style from './style.module.scss'

const AuthSlider = () => {
 const images = [slider1, slider2, slider3, slider4, slider5, slider6]
 const swiperRef = useRef<SwiperType | undefined>(undefined)
 const [activeIndex, setActiveIndex] = useState(0)

 return (
  <div className={style.sliderContainer}>
   {/* Custom Pagination Controls */}
   <div className={style.customPagination}>
    {images.map((_, i) => (
     <div
      key={i}
      onClick={() => swiperRef.current?.slideTo(i)}
      className={`${style.paginationDot} ${
       activeIndex === i ? style.active : ''
      }`}
     />
    ))}
   </div>

   <Swiper
    onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
    onSwiper={(swiper) => {
     swiperRef.current = swiper
    }}
    modules={[Autoplay, EffectFade]}
    effect="fade"
    autoplay={{
     delay: 3000,
     //  disableOnInteraction: false,
    }}
    // loop
    className={style.authSwiper}
   >
    {images.map((img, index) => (
     <SwiperSlide key={index}>
      <div className={style.slideImageWrapper}>
       <img src={img} alt={`Slide ${index + 1}`} />
      </div>
     </SwiperSlide>
    ))}
   </Swiper>
  </div>
 )
}

export default AuthSlider
